import { isLocalUrl } from '../localjs';

export default function () {
  const widgetName = 'ticketButton';
  const widgetOpts = ticketButtonOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: [''],
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    showDescription: true,
    moreButton: false,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    buyNowButton: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(`#${widgetName}`).remove();
      } else {
        createCustomTicketBtn(data.items[0]);
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    const { Title, URL } = widgetData;

    $(`#${widgetName}`).replaceWith(`
      <a class="ticket-button" href="${URL}" ${isLocalUrl(URL) ? '' : 'target="_blank"'}>${Title}</a>
      `);
  }
}
